<template>
  <div class="stock-apply-order-info">
    <!-- tab -->
    <ContentHeader
      path-set-type="append"
      :path-info="navPathInfo"
      :show-back="true"
    />
    <div class="content-container" v-loading="loading">
      <!-- 头部 -->
      <div class="order-info-block">
        <div class="order-header">
          <div class="order-number">订单编号: {{ orderInfo.applyNumber }}</div>
          <div class="order-date" v-show="orderInfo.applyDate">
            下单时间: {{ orderInfo.applyDate | parseTime }}
            <span class="ongoing" v-show="orderInfo.createDate"
              >此订单已经进行了{{ getInterval(orderInfo.createDate) }}天</span
            >
          </div>
          <div class="order-status">
            订单状态: {{ orderInfo.applyStatusName }}
          </div>
        </div>

        <stockStatusStep
          v-if="orderInfo.applyStatus !== 900 && orderInfo.applyStatus !== 1000"
          ref="stockStatusStep"
          :order-type="'apply'"
          :orderInfo="orderInfo"
        />
      </div>

      <!-- 主单信息 -->
      <div class="order-info-block">
        <div class="block-title">主单信息</div>
        <el-row :gutter="12">
          <el-form :model="orderInfo" label-width="120px">
            <el-col :span="12">
              <el-form-item label="订单编号">
                <span>{{ orderInfo.applyNumber }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="订单时间">
                <span v-show="orderInfo.applyDate">{{
                  orderInfo.applyDate | parseTime("{y}-{m}-{d}")
                }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="订单状态">
                <span>{{ orderInfo.applyStatusName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="下单人">
                <span>{{ orderInfo.clientName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="申请人">
                <span>{{ orderInfo.applyPerson }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="渠道">
                <span>{{ orderInfo.channelCode }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="售点名称">
                <span>{{ orderInfo.pocName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="售点年销量">
                <span>{{ orderInfo.pocTotalSale }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="M1名称">
                <span>{{ orderInfo.m1Name }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="M2名称">
                <span>{{ orderInfo.m2Name }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="M3名称">
                <span>{{ orderInfo.m3Name }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="用途信息">
                <span>{{ orderInfo.purposeInfo }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-show="orderInfo.approvalClientName">
              <el-form-item label="审核人">
                <span>{{ orderInfo.approvalClientName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-show="orderInfo.approvalDate">
              <el-form-item label="审核时间">
                <span>{{
                  orderInfo.approvalDate | parseTime("{y}-{m}-{d}")
                }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-show="orderInfo.approvalRemark">
              <el-form-item label="审核理由">
                <span>{{ orderInfo.approvalRemark }} </span>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-show="orderInfo.cancelDate">
              <el-form-item label="取消时间">
                <span>{{
                  orderInfo.cancelDate | parseTime("{y}-{m}-{d}")
                }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="!orderInfo.isSelfDelivery">
              <el-form-item label="是否自提">
                <span>{{ orderInfo.isSelfDelivery ? "是" : "否" }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-else>
              <el-form-item label="自提人信息">
                <span>{{ orderInfo.selfDeliveryInfo }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="收货人">
                <span>{{ orderInfo.receivePerson }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话">
                <span>{{ orderInfo.receivePhone }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="收货地址">
                <span v-if="!orderInfo.isSelfDelivery"
                  >{{ orderInfo.provinceName }} {{ orderInfo.cityName }}
                  {{ orderInfo.countyName }}
                  {{ orderInfo.detailAddress }}</span
                >
                <span v-else>自提</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="订单备注">
                <span>{{ orderInfo.applyRemark }}</span>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <!-- 订单明细 -->
      <div class="order-info-block">
        <div class="block-title">订单明细</div>
        <el-table :data="orderInfo.stockApplyDetailList" class="delivery-table">
          <!-- 商品修改数据展示 -->
          <el-table-column type="expand">
            <template slot-scope="scope">
              <el-form label-position="left" class="table-expand">
                <span v-if="scope.row.beforeQuantity">
                  <el-col :span="12">
                    <el-form-item label="商品名称">
                      <span>{{ scope.row.itemName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-show="scope.row.processDate">
                    <el-form-item label="修改时间">
                      <span>{{
                        scope.row.processDate
                          | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                      }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="修改人">
                      <span>{{ scope.row.processClientName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="修改理由">
                      <span>{{ scope.row.processRemark }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="商品初始数量">
                      <span>{{ scope.row.beforeQuantity }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="商品当前数量">
                      <span>{{ scope.row.itemQuantity }}</span>
                    </el-form-item>
                  </el-col>
                </span>
                <el-col :span="24" v-else style="text-align:center;">
                  <span>该商品数量未经修改</span>
                </el-col>
              </el-form>
            </template>
          </el-table-column>
          <!-- 表格商品数据展示 -->
          <el-table-column label="商品名称" align="center" prop="itemName" />
          <el-table-column label="商品编码" align="center" prop="itemCode" />
          <el-table-column
            label="所在仓库"
            align="center"
            prop="warehouseName"
          />
          <el-table-column label="区域编码 - 名称" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.orgCode }} - {{ scope.row.orgName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="品牌部门编码 - 名称" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.buType }} - {{ scope.row.buTypeName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="specParam"
            label="箱规"
            width="60"
            v-if="type === 'approve'"
          ></el-table-column>
          <el-table-column
            label="数量"
            align="center"
            width="100"
            prop="itemQuantity"
          />
          <el-table-column label="数量修改" width="80" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.beforeQuantity ? "是" : "否" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="toApprove"
            label="历史申请数量"
            align="center"
            width="110"
            prop="appliedQuantity"
          />
          <el-table-column
            v-if="toApprove"
            label="可用库存"
            align="center"
            width="100"
            prop="availableAmount"
          />
          <el-table-column
            v-if="toApprove"
            align="center"
            label="操作"
            width="130"
            class-name="small-padding"
          >
            <template slot-scope="scope">
              <div style="line-height: 35px;">
                <el-button
                  type="primary"
                  size="mini"
                  @click="updateItemQty(scope.row)"
                  >修改数量</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 审核人操作 -->
      <div class="order-info-block approve" v-if="toApprove">
        <el-button type="primary" @click="showApproveDialog">审核</el-button>
      </div>
    </div>

    <!-- 审核弹框 -->
    <approveDialog
      ref="approve-dialog"
      @success="approveSuccess"
      :selected-items="selectedItems"
    ></approveDialog>

    <!-- 修改商品数量弹框 -->
    <el-dialog
      title="修改商品数量"
      class="updateQty"
      :visible.sync="updateQtyDialog"
      width="70%"
    >
      <el-row :gutter="120">
        <el-form
          :model="updateForm"
          label-position="right"
          label-width="100px"
          :rules="updateRules"
          size="mini"
        >
          <el-col :span="12">
            <el-form-item label="商品名称">
              <span>{{ updateOrderInfo.itemName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品编码">
              <span>{{ updateOrderInfo.itemCode }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="区域">
              <span
                >{{ updateOrderInfo.orgCode }} -
                {{ updateOrderInfo.orgName }}</span
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="品牌部门">
              <span
                >{{ updateOrderInfo.buType }} -
                {{ updateOrderInfo.buTypeName }}</span
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="可用库存">
              <span>{{ updateOrderInfo.availableAmount }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品数量" prop="afterQuantity">
              <el-input
                v-model="updateForm.afterQuantity"
                placeholder="请输入商品数量"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注">
              <el-input
                v-model="updateForm.processRemark"
                placeholder="请输入修改商品数量备注"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="btn-red"
          size="small"
          :loading="updateLoading"
          @click="updateQty"
          >确认</el-button
        >
        <el-button class="btn-red-plain" size="small" @click="close"
          >关闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ContentHeader from '@/components/content-header'
import stockStatusStep from './components/stock-status-step'
import approveDialog from './components/approve-dialog'
import formValidators from '@/utils/formValidators'
export default {
  name: 'stock-apply-order-info',
  components: {
    ContentHeader,
    stockStatusStep,
    approveDialog
  },
  data () {
    return {
      loading: false,
      updateQtyDialog: false,
      updateLoading: false,
      updateOrderInfo: {},
      selectedItems: [],
      orderInfo: {},
      applyId: '',
      type: '',
      updateRules: {
        afterQuantity: [
          { required: true, message: '请输入商品数量', trigger: 'blur' },
          {
            validator: formValidators.checkInteger,
            message: '请输入整数',
            trigger: 'change'
          }
        ]
      },
      navPathInfo: [],
      updateForm: {
        applyId: '',
        applyDetailId: '',
        itemId: '',
        afterQuantity: '',
        processRemark: ''
      }
    }
  },
  computed: {
    // 待审核状态
    toApprove () {
      return Boolean(
        this.orderInfo.applyStatus === 100 && this.type === 'approve'
      )
    }
  },
  watch: {
    type (val) {
      if (val === 'approve') {
        this.navPathInfo = [{ path: '/stock/approve', name: '申请审核' }]
      } else {
        this.navPathInfo = [
          { path: '/stock/apply', name: '物资申请' },
          { path: '/stock/stock-apply-order', name: '物资申请订单列表' }
        ]
      }
    }
  },
  created () {
    this.applyId = this.$route.query.applyId
    this.type = this.$route.query.type
    this.init()
  },
  methods: {
    init () {
      this.getInfo()
    },
    getInfo () {
      this.selectedItems = []
      this.loading = true
      this.$store
        .dispatch('getApplyOrderInfo', this.applyId)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.orderInfo = res.data.resultData.stockApplyDetail
            this.selectedItems.push(this.orderInfo)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 展示审核弹框
    showApproveDialog () {
      this.$refs['approve-dialog'].show()
    },

    // 审核成功
    approveSuccess () {
      this.getInfo()
    },

    // 展示修改商品数量
    updateItemQty (row) {
      this.updateOrderInfo = row
      this.updateForm.afterQuantity = row.itemQuantity
      this.updateForm.applyId = row.applyId
      this.updateForm.applyDetailId = row.detailId
      this.updateForm.itemId = row.itemId
      this.updateQtyDialog = true
    },

    check () {
      if (!this.updateForm.afterQuantity) {
        this.$message.error('请填写商品数量')
        return false
      }
      return true
    },

    // 修改商品数量
    updateQty () {
      if (!this.check()) {
        return
      }
      this.updateForm.afterQuantity = Number(this.updateForm.afterQuantity)
      this.$confirm('是否确认修改该商品数量？', '提示', {
        confirmTextButton: '确认',
        cancelTextButton: '取消',
        type: 'warning'
      })
        .then(() => {
          this.updateLoading = true
          this.$store
            .dispatch('getApplyApproveUpdate', this.updateForm)
            .then(res => {
              if (res.data.resultCode === '0') {
                this.$message.success('修改数量成功')
                this.updateQtyDialog = false
                this.getInfo()
                this.updateForm = this.$options.data().updateForm
                this.updateOrderInfo = {}
              }
              this.updateLoading = false
            })
            .catch(() => {
              this.updateLoading = false
              this.$message.error('修改数量失败')
            })
        })
        .catch(() => {})
    },

    close () {
      this.updateQtyDialog = false
      this.updateForm = this.$options.data().updateForm
      this.updateOrderInfo = {}
    },

    // 获取间隔时间
    getInterval (time) {
      let date = new Date().getTime()
      let intervalDate = date - time
      return Math.floor(intervalDate / 86400000) + 1
    }
  }
}
</script>

<style lang="scss" scoped>
.order-info-block {
  border-radius: 10px;
  background-color: $base-white;
  padding: 20px;
  margin-bottom: 20px;

  .block-title {
    line-height: 32px;
  }
}
.el-form-item {
  margin-bottom: 0;
}
.order-header {
  .order-number {
    font-size: 18px;
    font-weight: 700;
    line-height: 30px;
  }
  .order-date {
    font-size: 16px;
    line-height: 30px;
  }
  .ongoing {
    margin-left: 15px;
  }
  .order-status {
    color: $base-red;
    padding: 16px 0;
  }
}
.order-detail {
  width: 100%;
  .item-image {
    width: 65px;
    height: 65px;
    margin: 0 auto;
    border: 1px solid $base-grey;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    img {
      max-width: 90%;
      max-height: 90%;
    }
  }

  .item-name {
    text-align: left;
    font-weight: 700;
  }

  .item-sum {
    font-weight: 700;
  }
}

.order-amount {
  border: 2px dashed #db3e3e;
  margin: 10px 0 0 0;
  padding: 0 20px;
  color: #db3e3e;
  font-size: 16px;
  line-height: 32px;
}

.dotted-block {
  border: 2px dashed $base-grey3;
  vertical-align: middle;
  height: 80px;
}

.budget-info-block {
  padding: 0 30px 0 0;
  p {
    margin-top: 30px;
  }
}
.entity-info-block {
  padding: 0 30px 0 0;
  p {
    margin-top: 15px;
    & + p {
      margin-top: -5px;
    }
  }
}

.delivery-table {
  ::v-deep th {
    background-color: $base-grey3;
  }

  .receipt-image {
    width: 60px;
    height: 60px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}

.order-remark {
  line-height: 32px;
}

.order-info-box {
  .order-info-card {
    width: 400px;
    height: 190px;
    border: 1px dashed #ccc;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 0 40px;
    div {
      margin-top: 9px;
    }
    &.card-red {
      border-color: $base-red;
      color: $base-orange;
      padding: 40px 0 0 130px;
      div {
        margin-top: 15px;
      }
    }
    .amount-msg {
      color: #333;
      font-size: 12px;
      margin-top: 5px !important;
    }
  }
}
.list-text {
  padding-bottom: 5px;
  display: inline-block;
}
.order-input {
  display: flex;
  margin: 10px 0;
  .el-input {
    width: 200px;
  }
}
.prints-img {
  display: flex;
  align-items: center;
  .print-img {
    width: 40px;
    height: 40px;
    margin-right: 5px;
  }
}
.prints-ai {
  margin: 10px 0;
}
.prints-info {
  & > div {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.sap-btn {
  text-align: right;
  margin-bottom: 15px;
}
.price-msg {
  margin-top: -5px;
}
.price-info {
  font-size: 12px;
  color: #999;
}

.approve {
  text-align: center;
}

.updateQty {
  .el-col {
    padding: 10px 0;
  }
}
</style>
